import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import {
  type ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  API_BASE_URL,
  ROOT_ASSET_OBIDS,
  STRIP_ONTOLOGY_PREFIX,
} from '@archimed/refinery-model-exploration';
import { appRoutes } from './app.routes';
import { LoadingInterceptor } from './core/interceptors/loading.interceptor';
import { provideMsalProviders } from './core/providers/msal.provider';
import { environment } from './environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideRouter(appRoutes),
    provideMsalProviders(),
    { provide: API_BASE_URL, useValue: environment.backend_url },
    { provide: ROOT_ASSET_OBIDS, useValue: ['517', '14372532'] },
    {
      provide: STRIP_ONTOLOGY_PREFIX,
      useValue: environment.stripOntologyPrefix ?? false,
    },
    { multi: true, provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor },
  ],
};
